module.exports = __webpack_public_path__ + "static/media/trash-2.59f7bab0.svg";